import request from '@/config/axios'

export interface ActivityStatFunnel {
  pv?: number
  uv?: number
  join?: number
  award?: number
  share?: number
  costAmount?: number
  days?: number
}

export interface ActivityStatDailyVO {
  id?: number
  activityId?: number
  statDate?: string
  pvCount?: number
  uvCount?: number
  joinCount?: number
  awardCount?: number
  shareCount?: number
  costAmount?: number
}

export const getActivityStatFunnel = (activityId: number) => {
  return request.get<ActivityStatFunnel>({
    url: '/promotion/activity-stat/funnel',
    params: { activityId }
  })
}

export const getActivityStatTrend = (activityId: number, days = 30) => {
  return request.get<ActivityStatDailyVO[]>({
    url: '/promotion/activity-stat/trend',
    params: { activityId, days }
  })
}

export const getActivityStatSummary = (activityId: number) => {
  return request.get<ActivityStatFunnel>({
    url: '/promotion/activity-stat/summary',
    params: { activityId }
  })
}
